(function() {

	var templateProductImages = '.template-product-gallery-images',
		templateProductThumbnails = '.template-product-gallery-thumbnails',
		templateProductFormVariants = '.template-product-form-variants',
		templateProductFormOption = '.template-product-form-option',
		templateProductFormOptionRadio = '.template-product-form-option-radio',
		templateProductFormSubmit = '.template-product-form-submit',
		templateProductFormVariantError = '.template-product-form-variant-error',
		productRecommendationsSection = '.product-recommendations';

	var currentVariantValue = '';
	var currentVariantValue2 = '';
	var optionLevel3 = false;

	var page_href = new URL( window.location.href );

	$( document ).ready( function() {

		if( $( '.nba-team-selector' ).length > 0 ) {

			if( ! page_href.searchParams.has( 'nba_team' ) && page_href.searchParams.get( 'nba_team' ) !== null ) {

				$( '.template-product-form-submit' ).attr( 'disabled', true );

			}

			$( '.nba-team-selector' ).change( function() {

				updateCurrentProductImageTeam( $( this ).val(), $( '.nba-theme-selector' ).val().split( '-' )[ 1 ] );

				//$( '.template-product-form-submit' ).attr( 'disabled', false );

			});

			$( '.nba-theme-selector' ).change( function() {

				updateCurrentProductImageTeam( $( '.nba-team-selector' ).val(), $( this ).val().split( '-' )[ 1 ] );

			});

		}

		if( page_href.searchParams.has( 'nba_theme' ) && page_href.searchParams.get( 'nba_theme' ) !== null ) {

			if( $( '.nba-theme-selector' ) ) {

				$( '.nba-theme-selector option' ).each( function() {

					if( $( this ).val().split( '-' )[ 1 ] === page_href.searchParams.get( 'nba_theme' ) ) {

						$( this ).prop( 'selected', true );
					}
				})

			}
		}

		if( page_href.searchParams.has( 'nba_team' ) && page_href.searchParams.get( 'nba_team' ) !== 'null' ) {

			if( $( '.nba-team-selector' ) ) {

				$( '.nba-team-selector' ).val( page_href.searchParams.get( 'nba_team' ) );

				for( var i = 0; i < window.theme.product.images.length; i++ ) {

					if( window.theme.product.images[ i ].indexOf( '_' + page_href.searchParams.get( 'nba_team' ) ) >= 0 && window.theme.product.images[ i ].indexOf( '_' + page_href.searchParams.get( 'nba_theme' ) ) >= 0 ) {

						$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

						if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

							$( '.image-team-container' ).addClass( 'active' );

						}

						if( ! $( '.default-container' ).hasClass( 'active') ) {

							$( '.default-container' ).addClass( 'active' );

						}

						break;

					} else if ( window.theme.product.images[ i ].indexOf( page_href.searchParams.get( 'nba_team' ) ) >= 0 &&  window.theme.product.images[ i ].indexOf( page_href.searchParams.get( 'nba_theme' ) ) === -1 ) {

						$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

						if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

							$( '.image-team-container' ).addClass( 'active' );

						}

						if( ! $( '.default-container' ).hasClass( 'active') ) {

							$( '.default-container' ).addClass( 'active' );

						}

					}

				}

			}

		}

		if( $( '.nhl-team-selector' ).length > 0 ) {

			if( ! page_href.searchParams.has( 'nhl_team' ) && page_href.searchParams.get( 'nhl_team' ) !== null ) {

				$( '.template-product-form-submit' ).attr( 'disabled', true );

			}

			$( '.nhl-team-selector' ).change( function() {

				if( $( document ).find( 'input:checked' ).length > 0 ) {

					let selectCheckbox = $( document ).find( 'input:checked' )[ 0 ];
					let variantValue = $( selectCheckbox ).val();

					updateCurrentProductImageTeamNHL( $( this ).val(), variantValue.toLowerCase()  );

				} else {

					updateCurrentProductImageTeamNHL( $( this ).val() );

				}

			});

		}

		if( page_href.searchParams.has( 'nba_theme' ) && page_href.searchParams.get( 'nba_theme' ) !== null ) {

			if( $( '.nba-theme-selector' ) ) {

				$( '.nba-theme-selector option' ).each( function() {

					if( $( this ).val().split( '-' )[ 1 ] === page_href.searchParams.get( 'nba_theme' ) ) {

						$( this ).prop( 'selected', true );
					}
				})

			}
		}

		if( page_href.searchParams.has( 'nhl_team' ) && page_href.searchParams.get( 'nhl_team' ) !== 'null' ) {

			if( $( '.nhl-team-selector' ) ) {

				$( '.nhl-team-selector' ).val( page_href.searchParams.get( 'nhl_team' ) );

				let currentVariant;

				if( page_href.searchParams.get( 'variant' ) ) {

					for( var v = 0; v < window.theme.product.variants.length; v++ ) {

						if( page_href.searchParams.get( 'variant' ) == window.theme.product.variants[ v ].id ) {

							currentVariant = window.theme.product.variants[ v ];

						}

					}

				}

				if( currentVariant ) {

					for( var i = 0; i < window.theme.product.images.length; i++ ) {

						if( ( window.theme.product.images[ i ].indexOf( page_href.searchParams.get( 'nhl_team' ) ) >= 0 ) && ( window.theme.product.images[ i ].indexOf( '_' + currentVariant.option1.toLowerCase() ) >= 0 ) && ( window.theme.product.images[ i ].indexOf( '_' + currentVariant.option2 ) >= 0 ) )  {

							$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

							if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

								$( '.image-team-container' ).addClass( 'active' );

							}

							if( ! $( '.default-container' ).hasClass( 'active') ) {

								$( '.default-container' ).addClass( 'active' );

							}

						}

					}

				} else {

					for( var i = 0; i < window.theme.product.images.length; i++ ) {

						if( ( window.theme.product.images[ i ].indexOf( page_href.searchParams.get( 'nhl_team' ) ) >= 0 ) ) {

							$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

							if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

								$( '.image-team-container' ).addClass( 'active' );

							}

							if( ! $( '.default-container' ).hasClass( 'active') ) {

								$( '.default-container' ).addClass( 'active' );

							}

						}

					}

				}

			}

		}

		var formatSearchValue = function( str ) {

			var splitStr = str.toLowerCase().split('_');

			for (var i = 0; i < splitStr.length; i++) {

				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);

			}

			return splitStr.join(' ');

		}

		var variantFilter = function( title ){

			return window.theme.product.variants.filter(function( item, key ){

				return item.title === title;

			});

		}

		var variantMaybeRedirect = function( variant ){

			if( variant && variant[ 0 ] ){

				var variantId = variant[ 0 ].id;

				if( variant[ 0 ].compare_at_price ) {

					$( '.price-check strike' ).text( '$' + ( ( variant[ 0 ].compare_at_price / 100 ).toFixed( 2 ) ) );

				} else {

					$( '.price-check strike' ).text( '' );

				}

				$( '.carousel' ).each( function( index, carousel ) {

					if( carousel.classList[ 1 ].split( 'carousel-' )[ 1 ] == variantId ) {

						$( '.carousel' ).addClass( 'opacity-0' );
						$( '.carousel' ).addClass( 'pointer-events-none' );

						$( carousel ).removeClass( 'opacity-0' );

						$( carousel ).removeClass( 'pointer-events-none' );

						$( '.carousel-' + variantId + ' .template-product-gallery-thumbnails' ).slick( 'setPosition' );
						$( '.carousel-' + variantId + ' .template-product-gallery-images' ).slick( 'setPosition' );
						$( '.carousel-' + variantId + ' .template-product-gallery-images' ).slick( 'slickGoTo', 0, false );
						$( '.carousel-' + variantId + ' .template-product-gallery-thumbnails' ).slick( 'slickGoTo', 0, false );

						$( '.template-product-gallery-image-container' ).removeClass( 'active' );

					}

				});

				$( '.product-variant-id' ).val( variantId );
				$( '.current-price' ).text( '$' + ( variant[0].price / 100 ) );

				if( parseInt( variant[ 0 ].id ) !== parseInt( variantId ) ){

					href.searchParams.set( 'variant', variant[ 0 ].id );

					if( $( '.nba-team-selector' ).length > 0 ) {

						href.searchParams.set( 'nba_team', $( '.nba-team-selector' ).val() );

					}

					if( $( '.nba-theme-selector' ).length > 0 ) {

						var themeParam = $( '.nba-theme-selector' ).val().split( '-' )[ 1 ];
						href.searchParams.set( 'nba_theme', themeParam  );

					}

					if( $( '.nhl-team-selector' ).length > 0 ) {

						href.searchParams.set( 'nhl_team', $( '.nhl-team-selector' ).val() );

					}

					window.location.href = href.toString();

				} else {

					$( templateProductFormSubmit ).attr( 'disabled', false );
					$( templateProductFormVariantError ).hide();

				}

			} else {

				$( templateProductFormSubmit ).attr( 'disabled', true );

			}

		}

		var updateCurrentProductImageTeam = function( team, theme ) {

			for( var i = 0; i < window.theme.product.images.length ; i++ ) {

				if( window.theme.product.images[ i ].indexOf( '_' + team ) >= 0 && window.theme.product.images[ i ].indexOf( '_' + theme ) >= 0 ) {

					$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

					if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

						$( '.image-team-container' ).addClass( 'active' );

					}

					if( ! $( '.default-container' ).hasClass( 'active') ) {

						$( '.default-container' ).addClass( 'active' );

					}

				} else if (
					window.theme.product.images[ i ].indexOf( team ) >= 0 &&
					window.theme.product.images[ i ].indexOf( 'TeamTipoff' ) === -1 &&
					window.theme.product.images[ i ].indexOf( 'OmbreTeamMesh' ) === -1 &&
					window.theme.product.images[ i ].indexOf( 'CentreCourt' ) === -1 &&
					window.theme.product.images[ i ].indexOf( 'OmbreVocab' ) === -1 &&
					window.theme.product.images[ i ].indexOf( 'TeamMesh' ) === -1
				) {

					$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.images[ i ] + ')' );

					if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

						$( '.image-team-container' ).addClass( 'active' );

					}

					if( ! $( '.default-container' ).hasClass( 'active') ) {

						$( '.default-container' ).addClass( 'active' );

					}

				}

			}

		}

		var updateCurrentProductImageTeamNHL = function( team, variant1, variant2 ) {

			if( team && !variant1 && !variant2 ) {

				for( var i = 0; i < window.theme.product.images.length ; i++ ) {

					if( window.theme.product.images[ i ].indexOf( '_' + team ) >= 0 ) {

						let newImageUrl = window.theme.product.images[ i ].split( '.png' )[ 0 ];
						newImageUrl = newImageUrl + '_800x800' + '.png' + window.theme.product.images[ i ].split( '.png' )[ 1 ];

						$( '.image-team' ).css( 'background-image', 'url(' + newImageUrl + ')' );

						if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

							$( '.image-team-container' ).addClass( 'active' );

						}

						if( ! $( '.default-container' ).hasClass( 'active') ) {

							$( '.default-container' ).addClass( 'active' );

						}

						return false;

					}

				}

			}

			if( team && variant1 && !variant2 ) {

				for( var i = 0; i < window.theme.product.images.length ; i++ ) {

					if( window.theme.product.images[ i ].indexOf( '_' + team ) >= 0 && window.theme.product.images[ i ].indexOf( '_' + variant1 ) >= 0 ) {

						let newImageUrl = window.theme.product.images[ i ].split( '.png' )[ 0 ];
						newImageUrl = newImageUrl + '_800x800' + '.png' + window.theme.product.images[ i ].split( '.png' )[ 1 ];

						$( '.image-team' ).css( 'background-image', 'url(' + newImageUrl + ')' );

						if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

							$( '.image-team-container' ).addClass( 'active' );

						}

						if( ! $( '.default-container' ).hasClass( 'active') ) {

							$( '.default-container' ).addClass( 'active' );

						}

					}

				}

			}

			if( team && variant1 && variant2 ) {

				for( var i = 0; i < window.theme.product.images.length ; i++ ) {

					if( window.theme.product.images[ i ].indexOf( '_' + team ) >= 0 && window.theme.product.images[ i ].indexOf( '_' + variant1 ) >= 0 && window.theme.product.images[ i ].indexOf( '_' + variant2 ) >= 0 ) {

						let newImageUrl = window.theme.product.images[ i ].split( '.png' )[ 0 ];
						newImageUrl = newImageUrl + '_800x800' + '.png' + window.theme.product.images[ i ].split( '.png' )[ 1 ];

						$( '.image-team' ).css( 'background-image', 'url(' + newImageUrl + ')' );

						if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

							$( '.image-team-container' ).addClass( 'active' );

						}

						if( ! $( '.default-container' ).hasClass( 'active') ) {

							$( '.default-container' ).addClass( 'active' );

						}

					}

				}

			}

		}

		var updateCurrentProductImage = function( variant ) {

			if( $( '.nba-team-selector' ).length > 0 || $( '.nhl-team-selector' ).length > 0 ) {

				return false;

			} else {

				if( variant.attr( 'id' ).includes( 'variant-1') ) {

					for( var b = 0; b < window.theme.product.variants.length; b++ ) {

						if( window.theme.product.variants[ b ].title.includes( variant.val() ) ){

							if( window.theme.product.variants[ b ].featured_image !== null && window.theme.product.variants[ b ].featured_image.src && window.theme.product.variants[ b ].featured_image.src !== null ) {

								//$( '.template-product-gallery-image' ).css( 'background-image', 'url(' + window.theme.product.variants[ b ].featured_image.src + ')' );
								$( $( '.image-team' )[ 0 ] ).css( 'background-image', 'url(' + window.theme.product.variants[ b ].featured_image.src + ')' );

								if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

									$( '.image-team-container' ).addClass( 'active' );

								}

								if( ! $( '.default-container' ).hasClass( 'active') ) {

									$( '.default-container' ).addClass( 'active' );

								}

								break;

							}

						}

					}

				} else if( variant.attr( 'id' ).includes( 'variant-2' ) ) {

					if( currentVariantValue === '' ) {

						if( window.location.href.includes( 'variant' ) ) {

							if( page_href.searchParams.has( 'nba_team' ) ) {

								var currentVariantId = window.location.href.split('variant=').pop().split('&nba_team')[0];

							} else if( page_href.searchParams.has( 'nba_theme' ) ) {


								var currentVariantId = window.location.href.split('variant=').pop().split('&nba_theme')[0];

							} else if( page_href.searchParams.has( 'nhl_team' ) ) {

								var currentVariantId = window.location.href.split('variant=').pop().split('&nhl_team')[0];

							} else {

								var currentVariantId = window.location.href.split('variant=').pop().split('#main-content')[0];

							}

							for( var c = 0; c < window.theme.product.variants.length; c++ ) {

								if( window.theme.product.variants[ c ].id == currentVariantId ) {

									currentVariantValue = window.theme.product.variants[ c ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

								}

							}

						} else {

							currentVariantValue = window.theme.product.variants[ 0 ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

						}

					}

					var currentSearchValue = formatSearchValue( currentVariantValue );

					for( var d = 0; d < window.theme.product.variants.length; d++ ) {

						if( window.theme.product.variants[ d ].title.includes( variant.val() ) && window.theme.product.variants[ d ].title.includes( currentSearchValue )  ){

							if( window.theme.product.variants[ d ].featured_image !== null && window.theme.product.variants[ d ].featured_image.src && window.theme.product.variants[ d ].featured_image.src !== null ) {

								//$( '.template-product-gallery-image' ).css( 'background-image', 'url(' + window.theme.product.variants[ d ].featured_image.src + ')' );
								$( $( '.image-team' )[ 0 ] ).css( 'background-image', 'url(' + window.theme.product.variants[ d ].featured_image.src + ')' );

								if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

									$( '.image-team-container' ).addClass( 'active' );

								}

								if( ! $( '.default-container' ).hasClass( 'active') ) {

									$( '.default-container' ).addClass( 'active' );

								}


								break;

							}

						}

					}

				} else if( variant.attr( 'id' ).includes( 'variant-3' ) ) {

					if( currentVariantValue === '' ) {

						if( window.location.href.includes( 'variant' ) ) {

							if( page_href.searchParams.has( 'nba_team' ) ) {

								var currentVariantId = window.location.href.split('variant=').pop().split('&nba_team')[0];

							} else if( page_href.searchParams.has( 'nba_theme' ) ) {


								var currentVariantId = window.location.href.split('variant=').pop().split('&nba_theme')[0];

							} else if( page_href.searchParams.has( 'nhl_team' ) ) {

								var currentVariantId = window.location.href.split('variant=').pop().split('&nhl_team')[0];

							} else {

								var currentVariantId = window.location.href.split('variant=').pop().split('#main-content')[0];

							}

							for( var c = 0; c < window.theme.product.variants.length; c++ ) {

								if( window.theme.product.variants[ c ].id == currentVariantId ) {

									currentVariantValue = window.theme.product.variants[ c ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

								}

							}

						} else {

							currentVariantValue = window.theme.product.variants[ 0 ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

						}

					}

					var currentSearchValue = formatSearchValue( currentVariantValue );

					for( var d = 0; d < window.theme.product.variants.length; d++ ) {

						if( window.theme.product.variants[ d ].title.includes( variant.val() ) && window.theme.product.variants[ d ].title.includes( currentSearchValue )  ){

							if( window.theme.product.variants[ d ].featured_image !== null && window.theme.product.variants[ d ].featured_image.src && window.theme.product.variants[ d ].featured_image.src !== null ) {

								//$( '.template-product-gallery-image' ).css( 'background-image', 'url(' + window.theme.product.variants[ d ].featured_image.src + ')' );
								$( $( '.image-team' )[ 0 ] ).css( 'background-image', 'url(' + window.theme.product.variants[ d ].featured_image.src + ')' );

								if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

									$( '.image-team-container' ).addClass( 'active' );

								}

								if( ! $( '.default-container' ).hasClass( 'active') ) {

									$( '.default-container' ).addClass( 'active' );

								}


								break;

							}

						}

					}

				}
			}

		}

		var updateCurrentProductImageFilmProcessing = function( variant ) {

			for( var b = 0; b < window.theme.product.variants.length; b++ ) {

				if( window.theme.product.variants[ b ].id == $( variant ).find( 'input' ).val() ) {

					if( window?.theme?.product?.variants[ b ]?.featured_image?.src ) {

						$( '.image-team' ).css( 'background-image', 'url(' + window.theme.product.variants[ b ].featured_image.src + ')' );

					}


					if( ! $( '.image-team-container' ).hasClass( 'active' ) ) {

						$( '.image-team-container' ).addClass( 'active' );

					}

					if( ! $( '.default-container' ).hasClass( 'active') ) {

						$( '.default-container' ).addClass( 'active' );

					}

					break;
				}
			}

		}

		var updateAvailableVariants = function( variant ) {

			if( currentVariantValue === '' ) {

				if( window.location.href.includes( 'variant' ) ) {

					if( page_href.searchParams.has( 'nba_team' ) ) {

						var currentVariantId = window.location.href.split('variant=').pop().split('&nba_team')[0];

					} else if( page_href.searchParams.has( 'nba_theme' ) ) {

						var currentVariantId = window.location.href.split('variant=').pop().split('&nba_theme')[0];

					} else if( page_href.searchParams.has( 'nhl_team' ) ) {

						var currentVariantId = window.location.href.split('variant=').pop().split('&nhl_team')[0];

					} else {

						var currentVariantId = window.location.href.split('variant=').pop().split('#main-content')[0];

					}

					for( var c = 0; c < window.theme.product.variants.length; c++ ) {

						if( window.theme.product.variants[ c ].id == currentVariantId ) {

							currentVariantValue = window.theme.product.variants[ c ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

						}

					}

				}else {

					currentVariantValue = window.theme.product.variants[ 0 ].option1.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

				}

			}

			$( '.template-product-form-option-radio' ).each( function( index, item ){

				if( $( this ).attr( 'id' ).includes( 'variant-3') ) {

					optionLevel3 = true;

					return false;

				}

			});

			if( variant.attr( 'id' ).includes( 'variant-1') ) {

				var replacementVariantValue = variant.val().replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

				$( '.template-product-form-variants-radio-icon' ).each( function( index, item ){

					var currentInput = $( this ).parent().prev( 'input' );

					if( $( this ).css( 'background-image' ).includes( '_' + currentVariantValue + '_' ) && !currentInput[ 0 ].id.includes( 'variant-1') ) {

						var imageUrl = $( this ).css( 'background-image' ).replace( 'url("', '' ).replace( '")', '' );
						imageUrl = imageUrl.replace( '_' + currentVariantValue + '_', '_' + replacementVariantValue + '_' );
						imageUrl = imageUrl.split('?')[0];
						imageUrl = imageUrl + '?' + Math.floor( ( Math.random() * 1000 ) );

						$( this ).css( 'background-image', 'url(' + imageUrl + ')' );

					}

				})

				currentVariantValue = replacementVariantValue;

				$( '.template-product-form-option-radio' ).each( function( index, item ){

					if( !this.id.includes( 'variant-1')  ) {

						$( this ).parent().removeClass( 'available' );
						$( this ).prop( 'checked', false );

					}

					for( var b = 0; b < window.theme.product.variants.length; b++ ) {

						if( window.theme.product.variants[ b ].title.includes( variant.val() ) && window.theme.product.variants[ b ].title.includes( this.value )  ){

							if( !$( this ).parent().attr( 'class' ).includes( 'avialable' ) ) {

								$( this ).parent().addClass( 'available' );

							}

						}

					}

				})

			}else if ( variant.attr( 'id' ).includes( 'variant-2') && optionLevel3 ) {

				var replacementVariantValue = variant.val().replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

				if( window.location.href.includes( 'variant' ) ) {

					if( currentVariantValue2 === '' ) {

						if( page_href.searchParams.has( 'nba_team' ) ) {

							var currentVariantId = window.location.href.split('variant=').pop().split('&nba_team')[0];

						} else if( page_href.searchParams.has( 'nba_theme' ) ) {


							var currentVariantId = window.location.href.split('variant=').pop().split('&nba_theme')[0];

						} else if( page_href.searchParams.has( 'nhl_team' ) ) {

							var currentVariantId = window.location.href.split('variant=').pop().split('&nhl_team')[0];

						} else {

							var currentVariantId = window.location.href.split('variant=').pop().split('#main-content')[0];

						}

						for( var c = 0; c < window.theme.product.variants.length; c++ ) {

							if( window.theme.product.variants[ c ].id == currentVariantId ) {

								currentVariantValue2 = window.theme.product.variants[ c ].option2.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

							}

						}

					}

					$( '.template-product-form-variants-radio-icon' ).each( function( index, item ){

						var currentInput = $( this ).parent().prev( 'input' );

						if( $( this ).css( 'background-image' ).includes( '_' + currentVariantValue2 + '_' ) && !currentInput[ 0 ].id.includes( 'variant-2' ) ) {

							var imageUrl = $( this ).css( 'background-image' ).replace( 'url("', '' ).replace( '")', '' );
							imageUrl = imageUrl.replace( '_' + currentVariantValue2 + '_', '_' + replacementVariantValue + '_' );
							imageUrl = imageUrl.split('?')[0];
							imageUrl = imageUrl + '?' + Math.floor( ( Math.random() * 1000 ) );

							$( this ).css( 'background-image', 'url(' + imageUrl + ')' );

						}

					})

					currentVariantValue2 = replacementVariantValue;

				} else {

					if( currentVariantValue2 === ''  ) {

						currentVariantValue2 = window.theme.product.variants[ 0 ].option2.replace( /\ /g, '_' ).replace( '(', '' ).replace( ')', '' ).replace( '"', '' ).replace( '&', '' ).replace( '®', '' ).replace( '$', '' ).replace( '™', '' ).toLowerCase();

					}

					$( '.template-product-form-variants-radio-icon' ).each( function( index, item ){

						var currentInput = $( this ).parent().prev( 'input' );

						if( $( this ).css( 'background-image' ).includes( '_' + currentVariantValue2 + '_' ) && !currentInput[ 0 ].id.includes( 'variant-2' ) ) {

							var imageUrl = $( this ).css( 'background-image' ).replace( 'url("', '' ).replace( '")', '' );
							imageUrl = imageUrl.replace( '_' + currentVariantValue2 + '_', '_' + replacementVariantValue + '_' );
							imageUrl = imageUrl.split('?')[0];
							imageUrl = imageUrl + '?' + Math.floor( ( Math.random() * 1000 ) );

							$( this ).css( 'background-image', 'url(' + imageUrl + ')' );

						}

					})

					currentVariantValue2 = replacementVariantValue;

				}

				var currentSearchValue = formatSearchValue( currentVariantValue );
				var replacementSearchValue = formatSearchValue( replacementVariantValue );

				$( '.template-product-form-option-radio' ).each( function( index, item ){

					if( !this.id.includes( 'variant-1') && !this.id.includes( 'variant-2')  ) {

						$( this ).parent().removeClass( 'available' );
						$( this ).prop("checked", false);

					}

					for( var b = 0; b < window.theme.product.variants.length; b++ ) {

						if( window.theme.product.variants[ b ].title.includes( currentSearchValue ) && window.theme.product.variants[ b ].title.includes( replacementSearchValue ) && window.theme.product.variants[ b ].title.includes( $( this ).val() ) ){

							if( !$( this ).parent().attr( 'class' ).includes( 'avialable' ) ) {

								$( this ).parent().addClass( 'available' );

							}

						}

					}

				})

			}

		}

		var currentDate = new Date();
		var currentMonth = currentDate.getMonth() + 1;
		var nextYear = currentDate.getFullYear() + 1;

		if ( currentMonth < 11 ) {

			$( '#designer_startMonth, #designer_startYear' ).css( 'color', 'black' );

		}

		if ( currentMonth === 11 || currentMonth === 12 ) {

			$( '#designer_startMonth' ).val( '1' );
			$( '#designer_startYear' ).val ( nextYear );
			$( '#designer_startMonth, #designer_startYear' ).css( 'color', 'black' );

		}

		var hideNonExistentVariants = function() {

			if( window.location.href.includes( 'variant' ) ) {

				if( page_href.searchParams.has( 'nba_team' ) ) {

					var currentVariantId = window.location.href.split('variant=').pop().split('&nba_team')[0];

				} else if( page_href.searchParams.has( 'nba_theme' ) ) {


					var currentVariantId = window.location.href.split('variant=').pop().split('&nba_theme')[0];

				} else if( page_href.searchParams.has( 'nhl_team' ) ) {

					var currentVariantId = window.location.href.split('variant=').pop().split('&nhl_team')[0];

				} else {

					var currentVariantId = window.location.href.split('variant=').pop().split('#main-content')[0];

				}

				for( var i = 0; i < window.theme.product.variants.length; i++ ) {

					if( window.theme.product.variants[ i ].id == currentVariantId ) {

						var currentVariant = window.theme.product.variants[ i ];

					}

				}

				var option1 = currentVariant.option1;
				var option2 = currentVariant.option2;

				if( currentVariant.option3 === null ) {

					$( '.template-product-form-option-radio' ).each( function( index, item ){

						for( var b = 0; b < window.theme.product.variants.length; b++ ) {

							if( this.value == window.theme.product.variants[ b ].option1 ){

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if( window.theme.product.variants[ b ].title.includes( option1 ) && window.theme.product.variants[ b ].title.includes( this.value ) ) {

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}

						}

					});

				}else {

					$( '.template-product-form-option-radio' ).each( function( index, item ){

						for( var b = 0; b < window.theme.product.variants.length; b++ ) {

							if( this.value == window.theme.product.variants[ b ].option1 ){

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if(  this.value == window.theme.product.variants[ b ].option2 && window.theme.product.variants[ b ].option1 == currentVariant.option1 ){

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if( window.theme.product.variants[ b ].title.includes( option1 ) && window.theme.product.variants[ b ].title.includes( option2 ) && window.theme.product.variants[ b ].title.includes( this.value ) ) {

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}

						}

					})

				}

			} else {

				if( window.theme.product.variants[ 0 ].option3 === null ) {

					var option1 = window.theme.product.variants[ 0 ].option1;

					$( '.template-product-form-option-radio' ).each( function( index, item ){

						for( var i = 0; i < window.theme.product.variants.length; i++ ) {

							if( this.value == window.theme.product.variants[ i ].option1 ){

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if( window.theme.product.variants[ i ].title.includes( option1 ) && window.theme.product.variants[ i ].title.includes( this.value )  ) {

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}

						}

					});

				}else {

					var option1 = window.theme.product.variants[ 0 ].option1;
					var option2 = window.theme.product.variants[ 0 ].option2;

					$( '.template-product-form-option-radio' ).each( function( index, item ){

						for( var i = 0; i < window.theme.product.variants.length; i++ ) {

							if( this.value == window.theme.product.variants[ i ].option1 ){

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if( this.value === window.theme.product.variants[ i ].option2 ) {

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}else if( window.theme.product.variants[ i ].title.includes( option1 ) && window.theme.product.variants[ i ].title.includes( option2 ) && window.theme.product.variants[ i ].title.includes( this.value )  ) {

								if( !$( '.template-product-form-option-item' )[ index ].classList.contains( 'available' ) ) {

									$( '.template-product-form-option-item' )[ index ].classList += ' available';

								}

							}

						}

					});

				}

			}

		}

		var loadProductRecommendationsIntoSection = function() {

			if ( productRecommendationsSection === null ) {
				return;
			}

			var productId = $( productRecommendationsSection ).data( 'productId' );
			var baseUrl = $( productRecommendationsSection ).data( 'baseUrl' );
			var limit = $( productRecommendationsSection ).data( 'limit' )
			var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;

			$( productRecommendationsSection ).parent( ).load( requestUrl );

		};

		document.addEventListener( "shopify:section:load", function( event ) {

			if ( event.detail.sectionId === "product-recommendations" ) {

				loadProductRecommendationsIntoSection();

			}

		});

		loadProductRecommendationsIntoSection();

		if( $( '.template-product-form-option-radio' ).length > 0 ) {

			hideNonExistentVariants();

		}

		$( '.template-product-form-option-radio' ).each( function( index, item ){

			if( $( this ).is( ':checked' ) ) {

				$( this ).parent().addClass( 'active' );

			}

			$( this ).on( 'click', function( event ) {

				updateAvailableVariants( $( this ) );
				updateCurrentProductImage( $( this ) );

				if( $( '.nhl-team-selector' ).length > 0 ) {

					if( $( document ).find( 'input:checked' ).length === 1 ) {

						updateCurrentProductImageTeamNHL( $( '.nhl-team-selector' ).val(), $( this ).val().toLowerCase() );

					}

				}

				setTimeout( function(){

					var selectedVariantId = $( '.product-variant-id' ).val();

					if( selectedVariantId ) {

						for( var v = 0; v < window.theme.product.variants.length; v++ ) {

							if( window.theme.product.variants[ v ].id == selectedVariantId ) {

								if( window.theme.product.variants[ v ].available ) {

									$( '.product-form__submit' ).attr( 'disabled', false );
									$( '.product-form__submit' ).text( 'Customize' );

								} else {

									$( '.product-form__submit' ).attr( 'disabled', true );
									$( '.product-form__submit' ).text( 'Sold Out' );

								}

							}

						}

					}

				}, 150 );

			});

		});

		$( '.custom-radio' ).each(function( index, item ) {

			$( this ).on( 'change', function( event ) {

				$( '.custom-radio-container' ).each( ( index, item ) => {

					$( item ).removeClass( '!border-blue' );
					$( item ).removeClass( 'text-blue' );
					$( item ).addClass( 'border-white' );

				});

				$( this ).parent().addClass( 'border-blue' );
				$( this ).parent().addClass( 'text-blue' );
				$( this ).parent().removeClass( 'border-white' );

				updateCurrentProductImageFilmProcessing( $( this ) );

			});

		});

		$( templateProductFormVariants ).on( 'change', function( event ){

			var variant = variantFilter( $( this ).val() );
			variantMaybeRedirect( variant );


		});

		$( templateProductFormOption ).on( 'change', function( event ) {

			var options = [];

			$( '.template-product-form-option' ).each(function( index, item ){
				options.push( $( item ).val() );
			});

			var variant = variantFilter( options.join( ' / ' ) );

			variantMaybeRedirect( variant );

		});

		$( templateProductFormOptionRadio ).on( 'click', function( event ){

			var options = [];

			$( templateProductFormOptionRadio ).each(function( index, item ){

				if( $( this ).is( ':checked' ) ) {

					options.push( $( item ).val() );
					$( this ).parent().addClass( 'active' );

				}else {

					$( this ).parent().removeClass( 'active' );

				}

			});

			var variant = variantFilter( options.join( ' / ' ) );

			variantMaybeRedirect( variant );

		})



		if( $( templateProductImages ).length ) {

			$( templateProductImages ).slick({
				infinite : true,
				slidesToShow : 1,
				slidesToScroll : 1,
				dots: $( templateProductImages ).children().length > 1,
				arrows : false,
				swipe : true,
				draggable : true
			});

			if( $( '.slick-dots' ).children().length > 11 ) {

				$( '.slick-dots' ).addClass( 'scrolling-dots' );

			}

			$( '.slick-dots li' ).on( 'click', function() {

				$( '.template-product-gallery-image-container' ).removeClass( 'active' );

			});

			$( '.template-product-gallery-thumbnail-container' ).on( 'click', function() {

				if( $( '.image-team-container') ) {

					if( $( '.image-team-container' ).hasClass( 'active' ) ) {

						$( '.image-team-container' ).removeClass( 'active' );

					}

					if( $( '.default-container' ).hasClass( 'active' ) ) {

						$( '.default-container' ).removeClass( 'active' );

					}

				}

				$( 'iframe' ).each( function() {

					this.contentWindow.postMessage( JSON.stringify({ event: 'command', func: 'stopVideo' }), '*');

				});

			});

			if( $( templateProductThumbnails ).length ){

				$( templateProductThumbnails ).slick({
					infinite : true,
					slidesToShow : 6,
					slidesToScroll : 1,
					asNavFor : templateProductImages,
					focusOnSelect : true,
					dots : false,
					arrows : true,
					vertical: true,
  					verticalSwiping: true,
					adaptiveHeight : false
				});

			}

		}

		$( window ).on( 'resize', function() {

			if( $( '.template-product-gallery-thumbnail' ).length > 6 ) {

				$( templateProductThumbnails ).slick( 'setPosition' );

			} else {

				$( templateProductThumbnails ).slick( 'slickSetOption', 'speed', 0, true ); // Temporarily disable animation
				$( templateProductThumbnails ).slick( 'setPosition' );
				$( templateProductThumbnails ).slick( 'slickSetOption', 'speed', 300, true ); // Restore animation
				$( templateProductThumbnails ).slick( 'slickGoTo', 0, false );

			}


		});

		$( '.variant-item' ).first().addClass( 'active' );

		$( '.variant-item' ).click(function() {

			$( '.variant-item' ).removeClass( 'active' );
			$( this ).addClass( 'active' );

		});

	});

})();
